import {unified} from "unified";
import markdown from "remark-parse";
import {waitForResult} from "../../lib/wait-for-result";
import {useMemo, useEffect, useState} from "react";
import useOriginalCopy from "../../lib/hooks/useOriginalCopy";
import cdxMentionMarkdownPlugin from "./plugins/cdxMentionPlugin";
import {cdxTextCompiler} from "./markdownToTextCompiler";
import cdxGithubMarkdownPlugin from "./plugins/cdxGithubMarkdownPlugin";
import {api} from "../../lib/api";
import {cdxBreakPlugin} from "./plugins/cdxBreakPlugin";

const markdownToText = (content) => {
  let result = null;
  const p = new Promise(
    (resolve) =>
      waitForResult(
        () =>
          unified()
            .use(markdown)
            .use(cdxBreakPlugin)
            .use(cdxMentionMarkdownPlugin, {
              render: (id) => {
                const user = api.getModel({modelName: "user", id});
                return user && !user.$meta.isDeleted() ? `@${user.name}` : `@unknown`;
              },
            })
            .use(cdxGithubMarkdownPlugin)
            .use(cdxTextCompiler)
            .processSync(content).value,
        (contents) => {
          result = contents;
          resolve(contents);
        }
      ),
    result
  );
  return result ? {type: "immediate", value: result} : {type: "promise", value: p};
};

export const useMarkdownToText = (content, opts) => {
  const orgOpts = useOriginalCopy(opts);
  const val = useMemo(() => content && markdownToText(content, orgOpts), [content, orgOpts]);
  const [result, setResult] = useState(val);
  useEffect(() => {
    setResult(val);
    if (!val) return;
    if (val.type === "promise") {
      setResult(val);
      let alive = true;
      val.value.then((value) => {
        if (alive) setResult({type: "resolved", value});
      });
      return () => {
        alive = false;
      };
    }
  }, [val]);
  return !result || result.type === "promise" ? null : result.value;
};
